const TWO_DIGIT_THRESHOLD = 10;

export const ModalFormatTimeForLhBlocking = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} seconds`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${
    remainingSeconds < TWO_DIGIT_THRESHOLD ? '0' : ''
  }${remainingSeconds} minutes`;
};

export const DragFormatTimeForLhBlocking = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < TWO_DIGIT_THRESHOLD ? '0' : ''}${remainingSeconds} m`;
};
